// extracted by mini-css-extract-plugin
module.exports = {"specList":"SpecList-module--spec-list--S66wh"};